import { render, staticRenderFns } from "./InvoiceReminderForm.vue?vue&type=template&id=477a5e34&scoped=true&"
import script from "./InvoiceReminderForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceReminderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477a5e34",
  null
  
)

export default component.exports